import React, { useEffect } from "react";
import { MdShoppingBasket } from "react-icons/md";
import { motion } from "framer-motion";
import { useDispatch } from "react-redux";
import { addItem } from "../../app/store/cartSlice";

const RowContainer = ({ flag, data, rowContainerRef }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (flag) {
      let timer = setInterval(() => {
        rowContainerRef.current.scrollLeft += 400;
      }, 10000);

      return () => {
        clearInterval(timer);
      };
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      ref={rowContainerRef}
      className={`my-12 w-full flex items-center scroll-smooth  ${
        flag
          ? "overflow-x-scroll scrollbar-none"
          : "overflow-x-hidden flex-wrap justify-center"
      }`}
    >
      {data &&
        data.map((item) => (
          <div
            key={item?.id}
            className=" w-300 min-w-[300px]  md:w-340 md:min-w-[340px] bg-cardOverlay rounded-lg hover:drop-shadow-lg h-auto mx-6 my-16 px-4  shadow-md backdrop-blur"
          >
            <div className="w-full flex items-center justify-between">
              <motion.img
                whileHover={{ scale: 1.2 }}
                src={item?.imageURL}
                alt=""
                className=" md:h-40 h-[8rem]  -mt-8 drop-shadow-2xl"
              />
              <motion.div
                whileTap={{ scale: 0.75 }}
                onClick={() => {
                  dispatch(addItem(item));
                }}
                className="w-8 h-8 min-w-[2rem] rounded-full bg-red-600 flex justify-center items-center cursor-pointer hover:shadow-md "
              >
                <MdShoppingBasket className="text-white" />
              </motion.div>
            </div>
            <div className="w-full flex flex-col items-end  justify-end">
              <p className="text-textColor font-semibold text-base md:text-lg">
                {item?.title}
              </p>
              <p className="mt-1 text-sm text-gray-500">
                {item?.calories} Calories
              </p>
              <div className="flex items-center gap-8">
                <p className="text-lg text-headingColor font-semibold">
                  <span className="text-sm text-red-500">$</span>
                  {item?.price}
                </p>
              </div>
            </div>
          </div>
        ))}
    </div>
  );
};

export default RowContainer;
